module.exports = __webpack_public_path__ + "img/products-trailers.d8fa464f.jpeg";